__turbopack_context__.v({
  "add-comment": "style-module-scss-module__SJTYIq__add-comment",
  "agent-card-footer": "style-module-scss-module__SJTYIq__agent-card-footer",
  "agent-card-title": "style-module-scss-module__SJTYIq__agent-card-title",
  "checkbox-container": "style-module-scss-module__SJTYIq__checkbox-container",
  "comment-box": "style-module-scss-module__SJTYIq__comment-box",
  "component": "style-module-scss-module__SJTYIq__component",
  "disclaimer-error": "style-module-scss-module__SJTYIq__disclaimer-error",
  "disclaimers": "style-module-scss-module__SJTYIq__disclaimers",
  "double-line-height": "style-module-scss-module__SJTYIq__double-line-height",
  "exp-theme": "style-module-scss-module__SJTYIq__exp-theme",
  "icons": "style-module-scss-module__SJTYIq__icons",
  "modal": "style-module-scss-module__SJTYIq__modal",
  "note": "style-module-scss-module__SJTYIq__note",
  "phone-number": "style-module-scss-module__SJTYIq__phone-number",
  "radio-button-group-container": "style-module-scss-module__SJTYIq__radio-button-group-container",
  "submit-button-container": "style-module-scss-module__SJTYIq__submit-button-container",
});
